/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.3.6",
    versionName: "0.2.0-nightly.2026.3.6",
    versionChannel: "nightly",
    buildDate: "2026-03-06T00:15:44.435Z",
    commitHash: "df4c12d15e22a71e739bdb144aec93d481e9c1fa",
};
